import useCurrentUserRoles from 'api/users/useCurrentUserRoles';
import { Navigate, Outlet } from 'react-router';
import { DONATIONS_PATH } from 'src/core/paths/paths';

const RequireCoordinatorOrLegalRep = () => {
  const { isCoordinator, isLegalRep, isAdmin } = useCurrentUserRoles();
  if (!isCoordinator && !isLegalRep && !isAdmin) {
    return <Navigate to={DONATIONS_PATH} replace />;
  }
  return <Outlet />;
};

export default RequireCoordinatorOrLegalRep;
